module.exports = __webpack_public_path__ + "img/default.f0bb39e6.png";